import { Button } from 'app/components/ui/button';
import {
  addCalendarTicketsToCart,
  addTicketsToCart,
} from 'app/pages/TicketSalePage/slice';
import { Minus, Plus } from 'lucide-react';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { dateFormatForCalendar } from 'utils/calendar';

interface TicketQuantityButtonsProps {
  ticketId: string;
  quantity: number;
  setQuantity: (value: number) => void;
  ticketHasCalendar: boolean;
  ticketAvailableQuantity: number;
  ticketIsSellable: boolean;
  selectedDate: DateTime | undefined;
}

const TicketQuantityButtons: React.FC<TicketQuantityButtonsProps> = ({
  ticketId,
  quantity,
  setQuantity,
  ticketHasCalendar,
  ticketAvailableQuantity,
  ticketIsSellable: initialTicketIsSellable,
  selectedDate,
}) => {
  const dispatch = useDispatch();

  const handleClick = value => {
    setQuantity(value > 0 ? value : 0);
    if (ticketHasCalendar) {
      dispatch(
        addCalendarTicketsToCart({
          ticketId: ticketId,
          quantity: value,
          date: (selectedDate as DateTime).toFormat(dateFormatForCalendar),
        }),
      );
    } else {
      dispatch(addTicketsToCart({ ticketId: ticketId, quantity: value }));
    }
  };

  const ticketIsSellable = initialTicketIsSellable
    ? quantity < ticketAvailableQuantity
    : initialTicketIsSellable;

  return (
    <div className="flex items-center">
      <Button
        disabled={quantity === 0}
        size="icon"
        onClick={() => handleClick(quantity - 1)}
      >
        <Minus size={24} />
      </Button>
      <p className="p1-medium w-[35px] text-center">{quantity}</p>
      <Button
        disabled={!ticketIsSellable}
        size="icon"
        onClick={() => handleClick(quantity + 1)}
      >
        <Plus size={24} />
      </Button>
    </div>
  );
};

export default TicketQuantityButtons;
